<template lang="pug">
	.wrapper
		.main-content(v-if="!showError")
			.box
				form.input-box(@submit.prevent="search()")
					sfc-input.desktop(v-model="searchTerm" :flat="false" :searchIcon="true" placeholder="Search")
					sfc-input.mobile(v-model="searchTerm" :flat="false" :searchIcon="false" placeholder="Search")
					input.hidden-button(type="submit")
				.button-box.desktop
					sfc-simple-button(text="Search" :blue="true" @click="!disableSearchAsComponent ? search() : goToSearch(searchTerm)")
				.button-box.mobile
					a.button-mobile(@click="search()")
						img(:src="`${$store.state.config.s3ResourceHost}/images/icon-search-white.svg`" alt="Search Icon")
					
			.resume-results(v-show="total != 0 && actualSearchTerm != ''")
				p You searched for '{{actualSearchTerm}}' and got&nbsp;
					span.bold-style {{total | currency("","0")}} results
				.text-right
					span(v-show="actualSearchTerm != '' || searchOnlyByTag")
						| Showing {{((pageNumber - 1) * 12) + 1}} - {{lastPageResultsTotal()}}
			.resume-no-results(v-show="total == 0 && ready")
				p You searched for '{{actualSearchTerm}}' and got&nbsp;
					span.bold-style no results
			.wrapper-search-results(:class="{'with-border-bottom': actualSearchTerm != '' && total > 0}")
				.result-box(v-for="(result, index) of results" :key="index")
					.search-info-container
						.top
							.section
								h2.art-title
									a(:href="result._source.url")
										| {{result._source.title}}
							.tag.article(:class="tagClass(result._source.page_tag)")
								| {{result._source.page_tag}}
						.resume
							span(v-html="paragraphTruncator(result._source.description)")
					.add-ad.desktop(v-if="index == 5 && total > 6")
						no-ssr
							sfc-dfp-ad(:ad-unit='`Savingforcollege_college_savings_101_page_topleaderboard`' sizes='[[600,230], [728,90]]')
					.add-ad.mobile(v-if="index % 11 == 0 && total > 12 && index / 10 < 10 && index > 10")
						no-ssr
							sfc-dfp-ad(:ad-unit='`Savingforcollege_other_mobile_leaderboard`' sizes='[[320,50]]' :mobile="true")
				//.mobile-mark(v-observe-visibility="{callback: loadMoreResults, intersection:{rootMargin: '400px'}}")
				//spinner(v-show="loadingMoreMobile" size="20")
			
			div(v-show="(actualSearchTerm != '' || searchOnlyByTag)")
				.page-buttons
					.box-left
						a.btn-box-left(@click="search('previous', $event, searchOnlyByTag)" v-show="pageNumber > 1")
							span.left-arrow-prev
							span Previous
					.box-right
						a.btn-box-right(@click="search('next', $event, searchOnlyByTag)" v-show="pageNumber < Math.ceil(total/10)")
							span Next
							span.right-arrow-next

		.error(v-if="showError")
			.error-container
				.error-image-container
					img(:src="`${$store.state.config.s3ResourceHost}/images/icon-search-no-result-blue.svg`"  alt="Search had no results")
				h2.error-title Oops! Something went wrong
				p.error-subtitle Please try searching again
		.side-ads
			.side-menu
				ul
					li Results from
					li(v-for="tag of tags" :key="tag._source.title" :class="{'active': currentResultFrom == tag._source.title}" @click="!disableSearchAsComponent ? setCurrentResultFrom(tag._source.title) : goToSearch(tag._source.title)") {{tag._source.title}}
					
			.sidebar-large(v-if="!$store.state.userIsLoggedIn" style="margin-bottom: 30px;")
				sfc-dfp-ad(ad-unit="savingforcollege_other_right_wide_skyscraper" sizes="[[160,600],[300, 600],[300, 250]]")
			.text-ads(v-if="!$store.state.userIsLoggedIn")
				div
					sfc-dfp-ad(ad-unit="savingforcollege_other_right_text_1" sizes="[[160,160],[300,80]]" delay="200")
				div
					sfc-dfp-ad(ad-unit="savingforcollege_other_right_text_2" sizes="[[160,160],[300,80]]" delay="200")
				div
					sfc-dfp-ad(ad-unit="savingforcollege_other_right_text_3" sizes="[[160,160],[300,80]]" delay="200")
			.side-menu-sticky(v-show="total > 10")
				ul
					li Results from
					li(v-for="tag of tags" :key="tag._source.title" :class="{'active': currentResultFrom == tag._source.title}" @click="!disableSearchAsComponent ? setCurrentResultFrom(tag._source.title) : goToSearch(tag._source.title)") {{tag._source.title}}
					

</template>

<style lang="stylus">
	@import '~assets/css/redesign-v1/variables.styl'
	.wrapper
		display: flex
		display: -webkit-flex
		width: 100%
		justify-content: space-between
		padding: 40px 0 104px
		border-top: 1px solid gray-disabled
		@media (max-width: 992px)
			padding: 24px 0 40px
		.main-content
			flex: 2
			padding-right: 40px
			@media (max-width: 992px)
				padding-right : 0px
			.box
				display: flex
				flex-direction: row
				justify-content: space-between
				align-items: center
				.input-box
					flex: 2
					input.hidden-button
						display: none
					.tb
						margin: 0!important
					.desktop
						@media (max-width: 575px)
							display: none
						label
							input
								padding-left: 30px
							span.search-icon
								margin-left: 8px
					.mobile
						@media (min-width: 576px)
							display: none
				.button-box
					flex: 1
					margin-left: 24px
					max-width: 200px
					&.desktop
						@media (max-width: 575px)
							display: none
					&.mobile
						max-width: unset
						margin-left: 16px
						@media (min-width: 576px)
							display: none
						.button-mobile
							background-color: blue-primary
							width: 100%
							height: 100%
							padding: 13px 32px
							border-radius: 25px
			.resume-results
			.resume-no-results
				font-size: body-font-size
				color: body-font-color-black
				font-family: main-font!important
				font-weight: body-font-light
				.text-right
					font-size: body-font-size-md 
					color: gray-40
					font-family: main-font!important
					font-weight: body-font-light
				.bold-style
					font-weight: body-font-weight-medium
			.wrapper-search-results
				margin-top: 0px
				margin-bottom: 52px
				&.with-border-bottom
					border-bottom: 1px solid gray-disabled
				.result-box
					padding-bottom: 24px
					border-top: 1px solid blue-20
					padding-top: 24px
					&:first-of-type
						border-top: none
					.add-ad
						text-align: center
						border-top: 1px solid gray-disabled
						padding: 0
						margin: 50px auto 0px
						padding-top: 40px
						padding-bottom: 16px
						&.mobile
							@media(min-width: 576px)
								display: none
						&.desktop
							@media(max-width: 575px)
								display: none
					.search-info-container
						.top
							display: flex
							flex-direction: row
							justify-content: space-between
							align-items: baseline
							@media(min-width: 993px) and (max-width: 1222px)
								flex-direction: column
								align-items: flex-start
							@media(max-width: 575px)
								flex-direction: column
								align-items: flex-start
							.section
								flex: 1
								@media(min-width: 993px) and (max-width: 1222px)
									padding-bottom: 8px
								@media(max-width: 575px)
									padding-bottom: 8px
								h2.art-title
									margin: 0
									padding: 0
									a
										color: blue-primary!important
										font-size: body-font-size-lg !important
										font-weight: body-font-weight-strong!important
										@media(max-width: 575px)
											font-size: body-font-size!important
							.tag
								margin-left: 24px
								padding: 5px 15px
								width: 151px
								text-align: center
								background-color: blue-primary
								font-size: body-font-size-sm
								font-weight: body-font-weight-medium-light
								text-transform: none
								border-radius(2px)
								color: #FFF
								border: 0
								@media(min-width: 993px) and (max-width: 1222px)
									margin-left: 0px
								@media(max-width: 575px)
									margin-left: 0px
								&.article
									background-color: blue-80
								&.plan-info
									background-color: success
								&.guides
									background-color: warning-yellow
								&.tools-and-calculators
									background-color: orange-secondary
								&.q-and-a
									background-color: gray-50
						.resume
							color: body-font-color-black!important
							font-size: body-font-size!important
							margin-top: 8px
							font-weight: body-font-light
			.page-buttons
				display: flex
				width: 100%
				justify-content: space-between
				font-weight: body-font-weight-strong
				color: blue-primary !important
				font-size: body-font-size-md
				line-height: normal
				.box-left
					flex: 1
					display: flex
					justify-content: flex-start
				.box-right
					flex: 1
					display: flex
					justify-content: flex-end
				.btn-box-left
					text-decoration: none
					width: 120px
					padding: 10px
					border: solid 2px blue-primary
					background-color: #ffffff
					cursor: pointer
					border-radius: 4px
					display: flex
					justify-content: flex-start
					align-items: center
					&:hover
						background-color: blue-20
					.left-arrow-prev
						margin-right: 15px
						border-top: 6px solid transparent
						border-bottom: 6px solid transparent
						border-right: 6px solid blue-primary
				.btn-box-right
					text-decoration: none
					width: 120px
					padding: 10px
					border: solid 2px blue-primary
					background-color: #ffffff
					cursor: pointer
					border-radius: 4px
					display: flex
					justify-content: flex-end
					align-items: center
					&:hover
						background-color: blue-20
					.right-arrow-next
						width: 0px
						margin-left: 24px
						border-top: 6px solid transparent
						border-bottom: 6px solid transparent
						border-left: 6px solid #1e6bd6
		.error-container
			text-align: center
			.error-image-container
				margin-top: 50px
			.error-title
				margin-top: 40px
				color: sfc-blue-link
			.error-subtitle
				font-weight: body-font-weight
				margin-bottom: 150px
		.side-ads
			flex: 1
			width: 100%
			max-width: 300px
			@media (max-width: 992px)
				display: none
			.side-menu-sticky
			.side-menu
				width: 100%
				margin-bottom: 40px
				ul
					padding: 0
					list-style: none
					li
						border-left: 4px solid blue-20
						padding: 0 0 5px 25px
						color: body-font-color-black!important
						font-size: body-font-size-md!important
						padding-top: 8px
						font-weight: body-font-light
						cursor: pointer
						&:first-of-type
							font-weight: body-font-weight-medium!important
							&:hover
								border-left: 4px solid blue-20
						&:hover
							border-left: 4px solid blue-primary
							font-weight: body-font-weight-medium
			.side-menu-sticky
				position: sticky
				top: 30px
				margin-top: 30px
</style>

<script>
	import Vue from 'vue'
	import SfcSidebar from '@/common/components/sfc-sidebar.vue'
	import SfcBreadcrumbs from '@/common/components/sfc-breadcrumbs'
	import SfcTrackingService from "@/lib/sfc-tracking-service.js"
	import SfcSlider from '@/common/components/sfc-slider'
	import VueObserveVisibility from 'vue-observe-visibility'
	import Spinner from 'vue-simple-spinner/src/components/Spinner.vue'

	import SfcSimpleButton from '@/common/components/redesign-v1/sfc-simple-button'
	Vue.use(VueObserveVisibility)

	export default {
		components: {
			SfcSidebar,
			SfcBreadcrumbs,
			SfcSlider,
			Spinner,
			SfcSimpleButton
		},
		watchQuery: true,
		async mounted(){
			this.getSearchResults()
		},
		props:[
			'disableSearchAsComponent' // used to create links to /search instead of directly calling search()
		],
		data(){
			return {
				ready: false,
				searchTerm:"",
				actualSearchTerm: "",
				currentResultFrom: "All",
				pageNumber: 1,
				loadingMoreMobile: false,
				keepSearchingMobile: true,
				searchOnlyByTag: false,
				total: 0,
				results: [],
				tags: [],
				showError: false,
			}
		},
		methods:{
			/*/getHeight(){
				console.log("ENTRE")
				let pageContent = document.getElementsByClassName("wrapper-search-results")[0]
				console.log(pageContent.clientHeight)
				if(pageContent.clientHeight > 1000){
					document.getElementsByClassName("side-menu-sticky").classList.add("show")
				}
			},/*/
			async getSearchResults(){
				let response
				let actualSearchTerm = ""
				let searchTerm = ""
				let elasticQuery
				let elasticCountQuery
				let pageNumber = 1
				let tags = []
				let searchOnlyByTag = false
				let currentResultFrom = "All"
				let results = []
				let total = 0
				let showError = false

				try{
					let tagQuery = {
						sort: [
							{
								amount: {
									order: "desc"
								}
							}
						]
					}

					let tagResponse = await this.$axios.get(
						`${this.$store.state.config.searchApiHost}/page-tags/_search`,
						{
							params: {
								source: JSON.stringify(tagQuery),
								source_content_type: 'application/json'
							},
							auth:{
								username:"sfc_query",
								password:"sfc_query"
							}
						}
					)

					tags = tagResponse.data.hits.hits
					let tagsForCompare = tags.map( tag => tag._source.title)

					if(this.$route.query.page){
						pageNumber = parseInt(this.$route.query.page)
						if(isNaN(pageNumber)){
							pageNumber = 1
						}
					}

					if(pageNumber > 999){
						pageNumber = 999
					}

					if(this.$route.query.tag && tagsForCompare.indexOf(this.$route.query.tag) != -1){
						actualSearchTerm = this.$route.query.tag
						searchOnlyByTag = true
						currentResultFrom = this.$route.query.tag
						elasticQuery = {
							size: 12,
							from: ((pageNumber - 1) * 12),
							query: {
								bool:{
									should:[
										{match_phrase: {tags: this.$route.query.tag}}
									]
								}
							},
							_source: ["title", "description", "url", "page_tag"]
						}

					}else{
						if(this.$route.query.q){
							actualSearchTerm = this.$route.query.q
							searchTerm = this.$route.query.q

							elasticQuery = {
								size: 12,
								from: ((pageNumber - 1) * 12),
								query: {
									bool:{
										should:[
											{match: {title: {query: actualSearchTerm, boost: 6}}},
											{match: {page_tag: {query: actualSearchTerm, boost: 5}}},
											{match: {tags: {query: actualSearchTerm, boost: 3}}},
											{match: {description: {query: actualSearchTerm, boost: 4}}},
											{match: {content: {query: actualSearchTerm, boost: 2}}},
											{match: {author: actualSearchTerm}},
										]
									}
								},
								_source: ["title", "description", "url", "page_tag"]
							}
						}else{
							elasticQuery = {
								size: 12,
								query: {
									match_all: {}
								},
								sort:[{date: {order: "desc"}}],
								_source: ["title", "description", "url", "page_tag"]
							}
						}
					}

					response = await this.$axios.get(
						`${this.$store.state.config.searchApiHost}/pages/_search`,
						{
							params: {
								source: JSON.stringify(elasticQuery),
								source_content_type: 'application/json'
							},
							auth:{
								username:"sfc_query",
								password:"sfc_query"
							}
						}
					)

					results = response.data.hits.hits
					total = response.data.hits.total

					if(results.length == 0 && total > 0 && pageNumber > 1){
						pageNumber = Math.ceil(total / 10)
						elasticQuery = {
							size: 12,
							from: ((pageNumber - 1) * 12),
							query: {
								bool:{
									should:[
										{match: {title: {query: actualSearchTerm, boost: 6}}},
										{match: {page_tag: {query: actualSearchTerm, boost: 5}}},
										{match: {tags: {query: actualSearchTerm, boost: 3}}},
										{match: {description: {query: actualSearchTerm, boost: 4}}},
										{match: {content: {query: actualSearchTerm, boost: 2}}},
										{match: {author: actualSearchTerm}},
									]
								}
							},
							_source: ["title", "description", "url", "page_tag"]
						}
						response = await this.$axios.get(
							`${this.$store.state.config.searchApiHost}/pages/_search`,
							{
								params: {
									source: JSON.stringify(elasticQuery),
									source_content_type: 'application/json'
								},
								auth:{
									username:"sfc_query",
									password:"sfc_query"
								}
							}
						)
						results = response.data.hits.hits
						total = response.data.hits.total
					}
				} catch (e){
					showError = true
					let mutationQuery = `
						mutation{
							send_elasticsearch_email(url: "${this.$route.fullPath}")
						}
					`
					response = await this.$httpService.graphql(mutationQuery)
				}

				this.ready = true
				this.results = results
				this.total = total
				this.actualSearchTerm = actualSearchTerm
				this.searchTerm = searchTerm
				this.pageNumber = pageNumber
				this.tags = tags
				this.searchOnlyByTag = searchOnlyByTag
				this.currentResultFrom = currentResultFrom
				this.showError = showError

			},
			lastPageResultsTotal(){
				if ((((this.pageNumber - 1) * 12) + 12) > this.total){
					return this.total
				}
				return ((this.pageNumber - 1) * 12) + 12
			},
			setCurrentResultFrom(result){
				this.searchTerm = result
				this.currentResultFrom = result
				this.search("", null, false)
			},
			tagClass(tag){
				if(tag == "Article")
					return "article"
				if(tag == "Plan Info")
					return "plan-info"
				if(tag == "Tools & Calculators")
					return "tools-and-calculators"
				if(tag == "Guides")
					return "guides"
				if(tag == "Q & A")
					return "q-and-a"

			},
			paragraphTruncator(paragraph){
				let paragraphToReturn = ""
				
				if (paragraph){
					if(paragraph.length <= 260){
						return paragraph
					}

					let words = paragraph.split(" ")
					for(let word of words){
						if(paragraphToReturn.length + word.length <= 260){
							paragraphToReturn += ` ${word}`
						}else{
							break
						}
					}
				}
				return `${paragraphToReturn}...`

			},
			loadMoreResults(isVisible, entry){
				if(isVisible){
					this.searchMoreMobile()
				}
			},
			async search(previousOrNext = "", $event, searchOnlyByTag){
				let query
				this.searchOnlyByTag = !!searchOnlyByTag

				if($event){
					$event.stopPropagation();
					$event.preventDefault();
				}

				if(!this.searchOnlyByTag){
					if(this.searchTerm == ""){
						return
					}

					if(this.searchTerm == this.actualSearchTerm && previousOrNext == ""){
						return
					}

					this.currentResultFrom = "All"
				}

				this.keepSearchingMobile = true

				if(previousOrNext == "next"){
					this.pageNumber += 1
				}

				if(previousOrNext == "previous"){
					this.pageNumber -= 1
				}

				if(previousOrNext == ""){
					this.pageNumber = 1
				}

				if(this.searchOnlyByTag){
					query = {
						size: 12,
						from: ((this.pageNumber - 1) * 12),
						query: {
							bool:{
								should:[
									{match_phrase: {tags: this.currentResultFrom}},
								]
							}
						},
						_source: ["title", "description", "url", "page_tag"]
					}
				}else{
					query = {
						size: 12,
						from: ((this.pageNumber - 1) * 12),
						query: {
							bool:{
								should:[
									{match: {title: {query: this.searchTerm, boost: 6}}},
									{match: {page_tag: {query: this.searchTerm, boost: 5}}},
									{match: {tags: {query: this.searchTerm, boost: 3}}},
									{match: {description: {query: this.searchTerm, boost: 4}}},
									{match: {content: {query: this.searchTerm, boost: 2}}},
									{match: {author: this.searchTerm}},
								]
							}
						},
						_source: ["title", "description", "url", "page_tag"]
					}
				}

				let response = await this.$axios.get(
					`${this.$store.state.config.searchApiHost}/pages/_search`,
					{
						params: {
							source: JSON.stringify(query),
							source_content_type: 'application/json'
						},
						auth:{
							username:"sfc_query",
							password:"sfc_query"
						}
					}
				)

				if(!searchOnlyByTag){
					this.actualSearchTerm = this.searchTerm
				}
				this.results = response.data.hits.hits

				let queryString = {}

				if(searchOnlyByTag){
					queryString.tag = this.currentResultFrom
				}

				if(!searchOnlyByTag){
					queryString.q = this.actualSearchTerm
				}

				if(this.$route.query.page || this.pageNumber > 1){
					queryString.page = this.pageNumber
				}

				this.$router.push({query: queryString})

				this.total = response.data.hits.total
				try{
					window.scrollTo(0,0)
				} catch (e) {
					console.error('An error occurred while scrolling to the top of the page:', e)
				}

			},
			async searchMoreMobile(){
				if(this.results.length == this.total || !this.keepSearchingMobile){
					return
				}
				this.pageNumber += 1

				let query

				if(this.currentResultFrom != "All"){
					query = {
						size: 12,
						from: ((this.pageNumber - 1) * 12),
						query: {
							bool:{
								should:[
									{match_phrase: {tags: this.currentResultFrom}},
								]
							}
						},
						_source: ["title", "description", "url", "page_tag"]
					}

				}else{

					if(this.actualSearchTerm.trim() == ""){
						return
					}

					query = {
						size: 12,
						from: ((this.pageNumber - 1) * 12),
						query: {
							bool:{
								should:[
									{match: {title: {query: this.actualSearchTerm, boost: 6}}},
									{match: {page_tag: {query: this.actualSearchTerm, boost: 5}}},
									{match: {tags: {query: this.actualSearchTerm, boost: 3}}},
									{match: {description: {query: this.actualSearchTerm, boost: 4}}},
									{match: {content: {query: this.actualSearchTerm, boost: 2}}},
									{match: {author: this.actualSearchTerm}},
								]
							}
						},
						_source: ["title", "description", "url", "page_tag"]
					}
				}

				this.loadingMoreMobile = true
				let response = await this.$axios.get(
					`${this.$store.state.config.searchApiHost}/pages/_search`,
					{
						params: {
							source: JSON.stringify(query),
							source_content_type: 'application/json'
						},
						auth:{
							username:"sfc_query",
							password:"sfc_query"
						}
					}
				)

				this.results = this.results.concat(response.data.hits.hits)
				this.total = response.data.hits.total

				if(response.data.hits.hits.length == 0){
					this.keepSearchingMobile = false
				}
				this.loadingMoreMobile = false

			},

			goToSearch(search_term){
				window.location.href = '/search?q=' + search_term;
				return true
			}

		}
	}
</script>
